import AddIcon from '@mui/icons-material/Add';
import ExperiencesIcon from '@mui/icons-material/Chat';
import NegativeIcon from '@mui/icons-material/ThumbDownSharp';
import PositiveIcon from '@mui/icons-material/ThumbUpSharp';
import AppBar from '@mui/material/AppBar';
import FloatingActionButton from '@mui/material/Fab';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useNavigate } from '@tanstack/react-router';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

import ContentView from '~/components/ContentView';
import DrawerButton from '~/containers/DrawerButton';
import { useExperiences, type Experience } from '~/hooks/api/useExperiences';
import { usePublisherMe } from '~/hooks/api/usePublisherMe';

import messages from './messages';
import styles from './styles.module.css';

export const Experiences = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { data: publisherMe } = usePublisherMe();
  const publisherId = publisherMe?.id;

  const { data: experiences, isLoading } = useExperiences({ publisherId });

  const gotoCreateExperience = () => {
    navigate({ to: '/experiences/new' });
  };

  const gotoViewExperience = (experience: Experience) => {
    navigate({ to: `/experiences/${experience.id}` });
  };

  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <DrawerButton />
            <Typography
              variant="h6"
              style={{ marginLeft: theme.spacing(2) }}
              sx={{
                color: 'inherit',
              }}
            >
              <FormattedMessage {...messages.header} />
            </Typography>
          </Toolbar>
        </AppBar>
      }
      floatingActionButton={
        <FloatingActionButton onClick={gotoCreateExperience} color="secondary">
          <AddIcon />
        </FloatingActionButton>
      }
      isLoading={isLoading}
    >
      {experiences && experiences.length > 0 ? (
        <List>
          {experiences.map((experience: Experience) => {
            return (
              <ListItem
                key={experience.id}
                onClick={() => gotoViewExperience(experience)}
              >
                <ListItemIcon>
                  {experience.isPositive ? <PositiveIcon /> : <NegativeIcon />}
                </ListItemIcon>
                <ListItemText
                  primary={experience.title}
                  secondary={`${moment(experience.events[0].eventDate).format('LLLL')} - ${
                    experience.events[0].location
                  }`}
                />
              </ListItem>
            );
          })}
        </List>
      ) : (
        <div className={styles['no-experiences-wrapper']}>
          <ExperiencesIcon
            style={{
              height: '128px',
              width: '128px',
              color: theme.palette.grey[500],
            }}
          />
          <span className={styles['no-experiences-label']}>
            <FormattedMessage {...messages.noExperiences} />
          </span>
        </div>
      )}
    </ContentView>
  );
};

export default Experiences;
